import React, { Component } from 'react';
import FAQService from '../../src/services/faq.service';
import FAQCategory from '../../src/models/FAQCategory';
import FAQOverviewPage from './views/pages/FAQOverviewPage'


type AppProps = {
  overviewID: number,
  language: string,
  persona: string,
  selectedCategoryID: number
}

type AppState = {
  categories: FAQCategory[],
  selectedCategory: FAQCategory
}

export default class App extends Component<AppProps, AppState> {
  constructor(props: AppProps) {
    super(props);
    this.state = {
      categories: [],
      selectedCategory: new FAQCategory()
    };
  }

  public async componentDidMount() {
    const service: FAQService = new FAQService();
    const categories: FAQCategory[] = await service.getFAQCategories(this.props.overviewID, this.props.language, this.props.persona);
    let selectedCategory = categories.find(category => category.id === this.props.selectedCategoryID);
    if (!selectedCategory) {
      const selectedCategoryIndex = 
      (this.props.selectedCategoryID >= 0 && this.props.selectedCategoryID < categories.length)
      ? this.props.selectedCategoryID
      : 0;
      selectedCategory = categories[selectedCategoryIndex]
    }
    

    this.setState({
      categories: categories,
      selectedCategory: selectedCategory
    })
  }

  public render() {
    return (
      <FAQOverviewPage categories={this.state.categories} selectedCategory={this.state.selectedCategory} />
    );
  }
}
